class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.state = {
      showingErrorMessage: false
    };
  }
  connectedCallback() {
    const minusButton = this.querySelector(".minus");
    const plusButton = this.querySelector(".plus");
    const quantityInput = this.querySelector(".quantity");
    minusButton == null ? void 0 : minusButton.addEventListener(
      "click",
      () => this.adjustQuantity(quantityInput, -1)
    );
    plusButton == null ? void 0 : plusButton.addEventListener(
      "click",
      () => this.adjustQuantity(quantityInput, 1)
    );
  }
  adjustQuantity(input, adjustment) {
    const currentVal = parseInt(input.value, 10);
    const newCount = currentVal + adjustment;
    const max = parseInt(input.max, 10);
    const min = parseInt(input.min, 10);
    if (newCount >= min && newCount <= max) {
      input.value = newCount.toString();
      return;
    }
    if (currentVal === max && adjustment > 0 && !this.state.showingErrorMessage) {
      const swatchGroup = this.closest(".product-swatches__form-group");
      if (!swatchGroup)
        return;
      swatchGroup.classList.add("product-swatches__form-group--max-reached");
      const maxError = document.createElement("span");
      maxError.classList.add("product-swatches__max-qty-error");
      maxError.innerHTML = "You've reached the max quantity";
      maxError.style.display = "block";
      maxError.style.color = "red";
      maxError.style.fontWeight = "bold";
      maxError.style.marginTop = "10px";
      maxError.style.marginBottom = "10px";
      maxError.style.position = "relative";
      maxError.style.zIndex = "10";
      swatchGroup.insertAdjacentElement("afterend", maxError);
      this.state.showingErrorMessage = true;
      setTimeout(() => {
        swatchGroup.classList.remove(
          "product-swatches__form-group--max-reached"
        );
        maxError.remove();
        this.state.showingErrorMessage = false;
      }, 3e3);
    }
    this.dispatchEvent(
      new CustomEvent("quantityChanged", { detail: newCount, bubbles: true })
    );
  }
}
customElements.define("uwp-quantity-selector", QuantitySelector);
